import { useState } from "react";
import { ClipboardList, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useStore } from "@/context/StoreContext";

const OPTIONS = [
  { kind: "count-sheet", label: "Product Count Sheet", hint: "Blank count fields, no system quantities" },
  { kind: "snapshot", label: "System Stock Snapshot", hint: "Current KhulaTill quantities" },
];

export default function StockListDownload() {
  const [busy, setBusy] = useState(false);
  const { active } = useStore();
  const download = async (kind) => {
    setBusy(true);
    try {
      const res = await api.get("/reports/stock-list", { params: { kind, store_id: active?.store_id, _ts: Date.now() }, responseType: "blob" });
      const served = res.headers["x-export-store-id"];
      if (active?.store_id && served && served !== active.store_id) throw new Error("store mismatch");
      const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || "Stock List.xlsx";
      const url = URL.createObjectURL(res.data);
      const a = Object.assign(document.createElement("a"), { href: url, download: name });
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success(`Downloaded ${name}`);
    } catch {
      toast.error("Could not generate the stock list");
    } finally {
      setBusy(false);
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" data-testid="download-stock-list-btn" disabled={busy} className="rounded-full">
          <ClipboardList className="w-4 h-4 mr-2" strokeWidth={1.5} />
          {busy ? "Preparing…" : "Download Stock List"}
          <ChevronDown className="w-4 h-4 ml-1" strokeWidth={1.5} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        {OPTIONS.map((o) => (
          <DropdownMenuItem key={o.kind} data-testid={`stock-list-${o.kind}-option`} onSelect={() => download(o.kind)}
            className="flex flex-col items-start gap-0.5 cursor-pointer">
            <span className="font-medium">{o.label}</span>
            <span className="text-xs text-muted-foreground">{o.hint}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
